import { render, staticRenderFns } from "./transaction_settings_new.vue?vue&type=template&id=1f879c94&"
import script from "./transaction_settings_new.vue?vue&type=script&lang=js&"
export * from "./transaction_settings_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports